import dataConfigs from '@/project/data'

export const endpoints = {
  user: dataConfigs.endpoints.user,
}
